<template>
  <div>
    <!-- :infinite-scroll-disabled="list.length == 0"  防止无限滚动机制和page初始化的时候同时请求数据 -->
    <el-table
      :data="list"
      border
      size="small"
      style="width: 1131px"
      :infinite-scroll-disabled="list.length == 0"
      v-el-table-infinite-scroll="loadMore"
    >
      <el-table-column prop="createdAt" label="时间" align="center" width="140">
        <template slot-scope="scope">
          {{ $util.ms2datetime(scope.row.createdAt) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="template.mailTemplateName"
        label="标题"
        align="center"
        width="200"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{ scope.row.template.mailTemplates[0].title }}
        </template>
      </el-table-column>
      <el-table-column label="标题和正文" align="center" width="100">
        <template slot-scope="scope">
          <el-popover placement="right" trigger="hover" width="600">
            <div>
              <el-tabs
                type="card"
                v-model="scope.row.template.activeLanguageTabName"
              >
                <el-tab-pane
                  v-for="item in scope.row.template.mailTemplates"
                  :key="item.language"
                  :name="item.language"
                >
                  <span slot="label"
                    ><i
                      v-if="item.title == ''"
                      class="el-icon-info"
                      style="margin-right: 5px"
                    ></i
                    >{{ `[${item.language}]` }}</span
                  >
                  <div>
                    <label style="display: block">{{
                      `[${item.language}] 标题：`
                    }}</label>
                    <el-input
                      v-model="item.title"
                      readonly
                      placeholder="（这个会在游戏里展示）"
                    ></el-input>
                  </div>
                  <div style="margin-top: 5px">
                    <label style="display: block">{{
                      `[${item.language}] 正文：`
                    }}</label>
                    <el-input
                      type="textarea"
                      rows="15"
                      v-model="item.content"
                      readonly
                      placeholder="（这个也会在游戏里展示）"
                    ></el-input>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
            <el-button slot="reference" size="small" icon="el-icon-view"
              >查看</el-button
            >
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
        prop="props"
        label="附件"
        align="center"
        width="350"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <div v-for="(item, index) in scope.row.propList" :key="index">
            {{ attachments[item.id] }} x {{ item.num }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="" label="收件人" align="center" width="140">
        <template slot-scope="scope">
          <div v-if="scope.row.isSelectPlayersByConditions">
            <span style="font-weight: bold">分区：</span
            >{{ scope.row.zoneId ? scope.row.zoneId : "全分区" }}
            <br />
            <span style="font-weight: bold">渠道：</span
            >{{ scope.row.channelId ? scope.row.channelId : "全渠道" }}
          </div>
          <div v-else>
            <span style="font-weight: bold"> 玩家ID：</span>
            <span v-if="scope.row.uidList.length == 1">{{
              scope.row.uidList[0]
            }}</span>
            <span v-else>
              <li v-for="(item, index) in scope.row.uidList" :key="index">
                {{ item }}
              </li>
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="发送人"
        align="center"
        prop="adminUsername"
        width="100"
      >
      </el-table-column>
      <el-table-column
        label="发送人角色"
        align="center"
        prop="role"
        width="100"
      >
        <template slot-scope="scope">
          <span v-for="(role, index) in roles" :key="index">
            {{ role.value == scope.row.role ? role.label : "" }}</span
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
  
<script>
const axios = require("axios");

export default {
  data() {
    return {
      list: [], // 定时邮件列表
      languages: [], // 所有的语言
      roles: [],
      form: {
        condition: "",
        value: "",
      },
      attachments: {},
    };
  },

  components: {},

  async created() {
    this.attachments = await this.$bizutil.loadAttachments(true);
    // 查询语言集合
    this.languages = await this.$bizutil.loadAvailableLanguages();
    this.roles = await this.$bizutil.loadRoles();
    // 拉取邮件模板集合
    await this.loadList(0, 10);
  },

  methods: {
    async loadMore() {
      await this.loadList(this.list.length, 10);
    },
    /**
     * 查询定时邮件集合
     */
    async loadList(skip, limit) {
      if (skip == 0) {
        // 清空表格数据
        this.list = [];
      }

      // 向服务器查询模板集合
      let resData = (
        await axios.post(
          `${this.$util.getBackendApiBase()}/v1/admin/queryAdminSendMailHistory`,
          {
            skip: skip,
            limit: limit,
            condition: this.form.condition,
            value: this.form.value,
          },
          {
            headers: {
              token: this.$bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message({
          message: resData.message,
          type: "error",
        });
        return;
      }

      let mails = resData.data.list || [];

      for (let mail of mails) {
        let languageTemplates = [];

        for (let language of this.languages) {
          let title = "";
          let content = "";

          for (let languageTemplateInResponse of mail.mailTemplate
            .mailTemplates) {
            if (languageTemplateInResponse.language == language) {
              title = languageTemplateInResponse.title;
              content = languageTemplateInResponse.content;
              break;
            }
          }

          languageTemplates.push({
            language: language,
            title: title,
            content: content,
          });
        }

        let propList = JSON.parse(mail.propList);

        this.list.push({
          id: mail.id,
          zoneId: mail.zoneId,
          channelId: mail.channelId,
          isSelectPlayersByConditions: mail.isSelectPlayersByConditions,
          uidList: mail.uidList,
          propList: propList,
          createdAt: mail.createdAt,
          adminUsername: mail.adminUsername,
          role: mail.role,
          template: {
            mailTemplateId: mail.mailTemplate.mailTemplateId,
            mailTemplateName: mail.mailTemplate.mailTemplateName,
            mailTemplates: languageTemplates,
            activeLanguageTabName: this.languages[0],
          },
        });
      }
    },
  },
};
</script>